module.exports = __webpack_public_path__ + "static/media/elbow2.7cac167e.png";